import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToastsService} from "../../../services/toasts.service";
import {ParcelService} from "../../../services/parcel/parcel.service";
import {ClientsService} from "../../../services/clients/clients.service";

declare var UIkit: any;

@Component({
  selector: 'app-adopt-unprocessable-parcel-to-client-modal',
  templateUrl: './adopt-unprocessable-parcel-to-client-modal.component.html',
  styleUrls: ['./adopt-unprocessable-parcel-to-client-modal.component.scss']
})
export class AdoptUnprocessableParcelToClientModalComponent implements OnInit {
  @Input('parcelId') parcelId: number = null;

  form: {
    id_parcel: number,
    id_client: number,
    is_emag_parcel: boolean,
    return: boolean,
  } = {
    id_parcel: null,
    id_client: null,
    is_emag_parcel: true,
    return: false,
  }

  constructor(
    private clientsService: ClientsService,
    private toastsService: ToastsService,
    private parcelService: ParcelService,
  ) { }

  ngOnInit(): void {}

  setClientData(client): void {
    this.clientsList = [];
    this.form.id_client = client.id;
    this.clientName = client.name;
  }

  clientsList = [];

  searchClient(input): void {
    this.clientsService.searchClient(input.value).subscribe(
      (response: Array<any>) => {
        this.clientsList = response;
      }
    );
  }

  clientName = null;

  submit(): void {
    this.form.id_parcel = this.parcelId;
    this.parcelService.adoptUnprocessableParcelToClient(this.form).subscribe(
      (response : any):void => {
        this.toastsService.showMessage('Zapisano klienta dla przesyłki nieprocesowalnej', 's');
        this.toastsService.showMessage('Za chwilę nastąpi próba przekierowania do nowego widoku przesyłki', 's');
        UIkit.modal('#adoptUnprocessableParcelToClientModal').hide();

        setTimeout(
          (): void => {
            this.parcelService.findByIdentifier(
              this.parcelId,
              ['internal_number']
            ).subscribe((internalNumberResponse: any) => {
              window.location.href = '/shipment/' + internalNumberResponse.internal_number
            })
          }, 7000
        );
      },
      (error: any) => {
        UIkit.modal('#adoptUnprocessableParcelToClientModal').hide();
        this.toastsService.showMessage('Wystąpił nieznany błąd', 'e');
      },
    );
  }
}
